import {getTranslationValue} from "@/i18n/utils/lang_overrides";
import {sanitize} from "@/helpers/html";

export default {
    computed: {
        products_message() {

            return this.$te("catalog.infoMessage") ? this.$t("catalog.infoMessage") : null
        }
    },
    methods: {
        products_translateProductName(product) {

            return getTranslationValue(product, ["genericName", "generic_name", "name"], this.$i18n);
        },
        products_translateProductDescription(product, allowedHtmlTags) {

            return sanitize(
                getTranslationValue(product, [
                    "genericDescription",
                    "generic_description",
                    "descriptionText",
                    "description_text", "description"
                ], this.$i18n),
                allowedHtmlTags
            );
        },
        products_translateProductNote(product) {

            return sanitize(getTranslationValue(product, "note", this.$i18n));
        },
        products_translateProductEstimatedShipDate(product) {

            if (product.estimated_ship_date) {

                return product.estimated_ship_date
                    ? sanitize(getTranslationValue(product.estimated_ship_date, ["message"], this.$i18n))
                    : null;
            }

            if (product.estimatedShipDate) {

                return product.estimatedShipDate
                    ? sanitize(getTranslationValue(product.estimatedShipDate, ["message"], this.$i18n))
                    : null;
            }

            return null;
        },
        products_getBreadcrumbsTree(includeActive) {

            const breadcrumbs = this.$route.meta && this.$route.meta.breadcrumbs
                ? this.$route.meta.breadcrumbs.slice(0)
                : [];

            const active = this.$store.getters["tree/active"];

            // Prepare products for mobile
            breadcrumbs.push({
                text: this.$t("breadcrumbs.catalog"),
                class: "d-md-none",
                dropdown: [
                    {
                        text: this.$t("breadcrumbs.all"),
                        active: "catalog" == this.$route.name,
                        to: {
                            name: "catalog"
                        }
                    }
                ].concat(
                    this.$store.getters["tree/items"].map(item => ({
                        text: getTranslationValue(item, "name", this.$i18n),
                        active: active && active.id == item.id,
                        to: {
                            name: "products.proxy",
                            params: {
                                grouping: this.$route.params.grouping,
                                grouping_id: item.id
                            }
                        }
                    }))
                )
            });

            // Prepare breadcrumbs for desktop
            this.$store.getters["tree/chain"].forEach(parent => breadcrumbs.push({
                text: getTranslationValue(parent, "name", this.$i18n),
                to: {
                    name: "products",
                    params: {
                        grouping_id: parent.id
                    }
                }
            }));

            if (includeActive && active) {

                breadcrumbs.push({
                    text: getTranslationValue(active, "name", this.$i18n),
                    to: {
                        name: "products",
                        params: {
                            grouping_id: active.id
                        }
                    }
                });
            }

            return breadcrumbs;
        },
        products_updateBreadcrumbsTree(active) {

            const breadcrumbs = this.products_getBreadcrumbsTree();

            if (active) {

                breadcrumbs.push({
                    text: getTranslationValue(active, "name", this.$i18n)
                });
            }

            setTimeout(() => this.breadcrumbs_set(breadcrumbs), 100);
        },
        products_updateBreadcrumbsProduct(product) {

            const breadcrumbs = this.products_getBreadcrumbsTree(true);

            if (product) {

                breadcrumbs.push({
                    text: getTranslationValue(product, "name", this.$i18n)
                });
            }

            setTimeout(() => this.breadcrumbs_set(breadcrumbs), 100);
        }
    }
}